// extracted by mini-css-extract-plugin
export default {"Header":"Intro_Header__w8DMz","Text":"Intro_Text__TOIAd"};